import React from 'react';
import './AboutChapterTimeline.scss';
import Reveal from '../Reveal/Reveal';
import TimelineItem from '../TimelineItem/TimelineItem';

// Timeline data array containing the history of the chapter from founding to present
// Each entry represents a significant milestone in the chapter's development
const timelinedata = [
  {
    date: 'Early March 2020',
    title: 'Founders Assemble',
    description: 'Jean Choi, Ryan Tsai, Vincent Chen, and Justin Tran began making plans to establish a chapter of Theta Tau at Cal Poly SLO and initiated correspondence with other founding members at chapters in the Southwest region amidst the COVID-19 pandemic.'
  },
  {
    date: 'End of March 2020',
    title: 'Founding Class',
    description: 'Jean, Ryan, Vincent, and Justin recruited 17 other Cal Poly engineers to create the founding class of 21 students.'
  },
  {
    date: 'March 2020 - October 2020',
    title: 'Working Towards Becoming a Colony',
    description: 'The founding class laid the groundwork for establishing a colony of Theta Tau, and held events to grow in service, profession, and brotherhood.'
  },
  {
    date: 'Late October 2020',
    title: 'Colony Petition',
    description: 'After months of preparation, the petition for colony recognition was finished and submitted to National for review.'
  },
  {
    date: 'November 7, 2020',
    title: 'Colony Status',
    description: 'After receiving a positive response from National, an initiation ceremony was held via Zoom, and Theta Tau SLO became an officially recognized colony.'
  },
  {
    date: 'November 2020',
    title: 'Working Towards Becoming a Chapter',
    description: 'Theta Tau SLO begins work to solidify and develop as a colony, while working towards the goal of attaining full chapter status.'
  },
  {
    date: 'June 1, 2024 - Present',
    title: 'SLO Candidate Chapter becomes Iota Zeta Chapter',
    description: 'Theta Tau SLO renames to the Theta Tau Iota Zeta Chapter and becomes an official Theta Tau Colony'
  },
]

// Component that displays the chapter's history in a timeline format
// Maps through timeline data to render each milestone as a TimelineItem component
function AboutChapterTimeline() {
    return (
      <section className="chapter-ledger" aria-labelledby="chapter-ledger-heading">
        {/* Main title for the timeline section */}
        <div className="chapter-ledger-heading">
          <Reveal as="h2" id="chapter-ledger-heading" variant="mask">Chapter History</Reveal>
        </div>
        {/* Container for all timeline items */}
        <div className="chapter-ledger-rows">
          {/* Map through timeline data and render each entry as a TimelineItem */}
          {timelinedata.map((entry, idx) => (
            <TimelineItem key={idx} index={idx} date={entry.date} title={entry.title} description={entry.description}/>
          ))}
        </div>
      </section>
    );
}

export default AboutChapterTimeline;
